<template>
  <div>
    <Pane :bottom="0" :showRemarks="false" />
    <a-card class="container">
      <a-form-model layout="inline" @keyup.enter.native="query">
        <a-row>
          <a-col :span="22">
            <a-form-model-item label="招待地点">
              <a-select v-model="form.entertainLocation" placeholder="全部" style="width: 120px" allowClear>
                <a-select-option value="inside">院内</a-select-option>
                <a-select-option value="outside">院外</a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item label="部门">
              <a-input v-model="form.deptName" placeholder="部门名称" style="width: 160px" allowClear />
            </a-form-model-item>

            <a-form-model-item label="是否有酒水">
              <a-select v-model="form.needAlcohol" placeholder="全部" style="width: 120px" allowClear>
                <a-select-option value="1">是</a-select-option>
                <a-select-option value="0">否</a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item label="审核通过时间">
              <a-range-picker v-model="form.date" />
            </a-form-model-item>

            <a-form-model-item>
              <a-space>
                <a-button @click="query" type="primary">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </a-space>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>

      <Padding />

      <a-table
        bordered
        :columns="columns"
        :dataSource="list"
        :loading="loading"
        :pagination="pagination"
        :rowKey="(record) => record.id"
        @change="handleTableChange"
      >
        <template slot="entertainLocation" slot-scope="text">
          {{ text === "inside" ? "院内" : text === "outside" ? "院外" : "—" }}
        </template>
        <template slot="needAlcohol" slot-scope="text, record">
          <template v-if="text === '1'">
            <a href="#" @click.prevent="showAlcohol(record)">是</a>
          </template>
          <template v-else>否</template>
        </template>
        <template slot="totalBudget" slot-scope="text">
          {{ text || '0.00' }}
        </template>
        <template slot="alcoholBudget" slot-scope="text">
          {{ text || '0.00' }}
        </template>
        <template slot="entertainType" slot-scope="text">
          <DataDictFinder dictType="entertainType" :dictValue="text" />
        </template>
      </a-table>
    </a-card>

    <a-modal
      :visible="alcoholModalVisible"
      @cancel="alcoholModalVisible = false"
      :footer="null"
      title="酒水清单"
      width="600px"
    >
      <a-table
        bordered
        :dataSource="alcoholModalData"
        :columns="alcoholColumns"
        :pagination="false"
        size="small"
        :rowKey="(row, index) => index"
      />
    </a-modal>
  </div>
</template>

<script>
import { queryApprovedEntertain } from "@/api/oa/entertain";
import moment from "moment";

export default {
  name: "approvedEntertainList",

  data() {
    return {
      form: {},
      loading: false,
      list: [],
      alcoholModalVisible: false,
      alcoholModalData: [],
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `共 ${total} 条`,
      },
      alcoholColumns: [
        { title: '酒水品名', dataIndex: 'name', width: 150 },
        { title: '单价(元)', dataIndex: 'unitPrice', width: 100 },
        { title: '数量', dataIndex: 'quantity', width: 80 },
        { title: '小计(元)', dataIndex: 'totalPrice', width: 100 },
      ],
      columns: [
        {
          title: "申请人",
          dataIndex: "applicantName",
          width: 120,
        },
        {
          title: "部门",
          dataIndex: "deptName",
          width: 200,
        },
        {
          title: "招待时间",
          dataIndex: "entertainTime",
          width: 120,
          customRender: (text) => {
            return text ? moment(text).format("YYYY-MM-DD") : "—";
          },
        },
        {
          title: "审核通过时间",
          dataIndex: "updateAt",
          width: 120,
          customRender: (text) => {
            return text ? moment(text).format("YYYY-MM-DD") : "—";
          },
        },
        {
          title: "招待地点",
          dataIndex: "entertainLocation",
          width: 100,
          scopedSlots: { customRender: "entertainLocation" },
        },
        {
          title: "招待类型",
          dataIndex: "entertainType",
          width: 120,
          scopedSlots: { customRender: "entertainType" },
        },
        {
          title: "招待对象",
          dataIndex: "entertainObject",
          width: 150,
        },
        {
          title: "对方人数",
          dataIndex: "guestCount",
          width: 80,
        },
        {
          title: "我方人数",
          dataIndex: "ourCount",
          width: 80,
        },
        {
          title: "总体预算(元)",
          dataIndex: "totalBudget",
          width: 120,
          scopedSlots: { customRender: "totalBudget" },
        },
        {
          title: "酒水预算(元)",
          dataIndex: "alcoholBudget",
          width: 120,
          scopedSlots: { customRender: "alcoholBudget" },
        },
        {
          title: "是否有酒水",
          dataIndex: "needAlcohol",
          width: 100,
          scopedSlots: { customRender: "needAlcohol" },
        },
        {
          title: "事由",
          dataIndex: "remarks",
          ellipsis: true,
        },
      ],
    };
  },

  mounted() {
    this.query();
  },

  methods: {
    showAlcohol(record) {
      this.alcoholModalData = record.applyMaterials || [];
      this.alcoholModalVisible = true;
    },

    getList() {
      const { date, entertainLocation, needAlcohol, deptName } = this.form;

      let startTime, endTime;
      if (Array.isArray(date) && date.length === 2) {
        startTime = date[0].format("YYYY-MM-DD");
        endTime = date[1].format("YYYY-MM-DD");
      }

      this.loading = true;
      queryApprovedEntertain({
        entertainLocation: entertainLocation || undefined,
        needAlcohol: needAlcohol || undefined,
        deptName: deptName || undefined,
        startTime,
        endTime,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res)) {
            const total = res.length;
            const { current, pageSize } = this.pagination;
            const start = (current - 1) * pageSize;
            const end = start + pageSize;
            this.list = res.slice(start, end);
            this.pagination.total = total;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    query() {
      this.pagination.current = 1;
      this.getList();
    },

    reset() {
      this.form = {};
      this.pagination.current = 1;
      this.getList();
    },

    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  margin-top: 8px;
}
</style>
